import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
const StyledCompactText = styled.div `
  h1,
  h2,
  h3,
  h4,
  h5,
  p {
    margin: 0;
  }
`;
export const GuidaCompactTextWrapper = ({ children }) => {
    return _jsx(StyledCompactText, { children: children });
};
//# sourceMappingURL=GuidaCompactTextWrapper.js.map